// 按模块的action, reducer整合体
const BACK_INFO_STANDBY = 'BACK_INFO_STANDBY';

export function setBackInfoStandby(params) {
  return dispatch => {
    return dispatch({
      type: BACK_INFO_STANDBY,
      data: params,
    });
  };
}

export function backInfoStandby(state = {}, action) {
  switch (action.type) {
    case BACK_INFO_STANDBY:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/back_info_standby.js